import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { NavigationLink } from "@edgetier/client-components";
import { AbsolutePaths } from "constants/routes";
import { PageNames } from "types-for/routes";

/**
 * Link to the users screen.
 * @returns A link to the page.
 */
const UsersLink = () => <NavigationLink label="Users" icon={faUsers} page={AbsolutePaths[PageNames.Users]()} />;

export default UsersLink;
